export default __webpack_public_path__ + "static/media/logo.87977303.svg";